import { useMutation } from 'urql';
import { CreateFileUploadInput, Mutation } from 'api';
import { CREATE_FILE_UPLOAD_MUTATION } from 'api/graphql/mutations/structure';

type MutationType = Pick<Mutation, 'createFileUpload'>;

export const useCreateFile = () => {
    const [state, executeMutation] = useMutation<MutationType>(CREATE_FILE_UPLOAD_MUTATION);

    const createFile = async (input: CreateFileUploadInput) => {
        const { error, data } = await executeMutation({ input });

        if (error) {
            return { error: error.graphQLErrors[0].extensions?.code };
        }

        return { data };
    };

    return {
        state,
        createFile,
    };
};
